<template>
	<div id="app">
		<div class="flex fulscreen">
			<div class="left-panel flex" :class="{'is-closed': !showLeftPanel}">
				<drag class="thumbnail" v-for="item in tilesheets" :transfer-data="item" :key="item.url">
					<div class="thumbnail-title">{{ item.name }}</div>
					<div class="thumbnail-img" :class="{'is-loading': item.data==null}" :style="item.style">
						<div class="lds-ring" v-if="!item.data"><div></div><div></div><div></div><div></div></div>
					</div>
				</drag>
			</div>
			<drop ref="mainPanel" class="main-panel flex" @dragenter="isDragging = true" @dragleave="isDragging = false" @dragover="onDragOver" @drop="onDrop">
				<div class="flex-center" v-if="viewers.length==0">
					<div class="text-msg">Drag-n-drop an image from the left panel<br/>onto here</div>
				</div>
				<volume-viewer ref="viewer" v-for="item in viewers" :layout="item" :key="item.key" @removeViewer="onRemoveViewer"></volume-viewer>
				<div class="drop-overlay" v-if="isDragging" :style="dropOverlayStyle" ></div>
				<div class="left-panel-toggle-wrapper" @click="showLeftPanel = !showLeftPanel"><div class="toggle-button"><div class="triangle-icon" :class="{'invert': !showLeftPanel}"></div></div></div>
			</drop>

			
		</div>
	</div>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop';
import VolumeViewer from './components/VolumeViewer';
import { imageToArray, getPixelDataFromImage } from './utils/imgToArray';


function mod(x, n)
{
	return (x % n + n) % n;
}

function countInArray(array, val)
{
	return array.filter(x => x == val).length;
}

class Viewer
{
	constructor(key)
	{
		this.key = key;
		this.style = {
			left: '0',
			top: '0',
			width: '100%',
			height: '100%',
		};
		this.classes = [];
	}
}

export default 
{
	name: 'app',
	components: 
	{
		Drag, 
		Drop,
		VolumeViewer,
	},
	data: function()
	{
		return {
			mouse: {
				x: 0,
				y: 0,
			},
			isDragging: false,
			dropOverlayStyle: {},
			dropOverlayInfo: 
			{
				overViewer: null,
				quadrants: [],
			},

			showLeftPanel: true,

			tilesheets: 
			[
				{
					name: 'T1',
					// url: 'https://s3-eu-central-1.amazonaws.com/advantis-public/t1.png',
					url: 'img/t1.png',
					data: null,
					style: {},
				},
				{
					name: 'DWI',
					// url: 'https://s3-eu-central-1.amazonaws.com/advantis-public/dwi.png',
					url: 'img/dwi.png',
					data: null,
					style: {},
				},
				{
					name: 'ColorMap',
					// url: 'https://s3-eu-central-1.amazonaws.com/advantis-public/colormap.png',
					url: 'img/colormap.png',
					data: null,
					style: {},
				},
			],
			// has references of the viewer in each quadrant, clockwise
			viewerQuadrants: [null, null, null, null], 
			viewers: [],
		};
	},
	watch: 
	{
		viewerQuadrants(newVal)
		{
			var list = [];
			for (let viewer of this.viewers)
			{
				let quadrants = [];
				for (var i = 0; i < 4; i++)
					if (this.viewerQuadrants[i] == viewer)
						quadrants.push(i);

				if (quadrants.length > 0)
					list.push(viewer);

				viewer.classes = [];
				if (quadrants.length == 4)
					viewer.style = 	{
										left: 0,
										top: 0,
										width: '100%',
										height: '100%',
									};

				if (quadrants.length == 2)
				{
					if (quadrants[0] == 0 && quadrants[1] == 3)
					{
						viewer.style =	{
											left: '0',
											top: '0',
											width: '100%',
											height: '50%',
										};
						viewer.classes = ['half-height'];
					}
					else if (quadrants[0] == 0) // implies quadrants[1] == 1
					{
						viewer.style =	{
											left: '50%',
											top: '0',
											width: '50%',
											height: '100%',
										};
					}

					if (quadrants[0] == 1) // implies quadrants[1] == 2
					{
						viewer.style =	{
											left: '0%',
											top: '50%',
											width: '100%',
											height: '50%',
										};
						viewer.classes = ['half-height'];
					}

					if (quadrants[0] == 2) // implies quadrants[1] == 3
					{
						viewer.style =	{
											left: '0%',
											top: '0%',
											width: '50%',
											height: '100%',
										};
					}
				}

				if (quadrants.length == 1)
				{
					viewer.classes = ['half-height'];
					if (quadrants[0] == 0 )
					{
						viewer.style =	{
											left: '50%',
											top: '0',
											width: '50%',
											height: '50%',
										};
					}
					
					if (quadrants[0] == 1)
					{
						viewer.style =	{
											left: '50%',
											top: '50%',
											width: '50%',
											height: '50%',
										};
					}

					if (quadrants[0] == 2) 
					{
						viewer.style =	{
											left: '0%',
											top: '50%',
											width: '50%',
											height: '50%',
										};
					}

					if (quadrants[0] == 3)
					{
						viewer.style =	{
											left: '0%',
											top: '0%',
											width: '50%',
											height: '50%',
										};
					}
				}
			} //  for loop end
			this.viewers = list;

			this.$nextTick( ()=>
			{
				if (this.$refs.viewer)
					for (let v of this.$refs.viewer)
						v.onResize();
			} )
		},

		showLeftPanel(newVal)
		{
			this.$nextTick( ()=>
			{
				this.onResize();
			} );
		}

	},
	created: function()
	{
		this.tilesheets.forEach((item) => 
		{
			var img = new Image();
			img.crossOrigin = "Anonymous";
			img.onload = ()=>
			{
				console.log(`...loaded img ${item.url}`);
				item.style['background-image'] = `url("${item.url}")`;

				console.log(`computing 3d tex...`);
				var src_data = getPixelDataFromImage(img).data;
				var dst_data = new Uint8Array(src_data.length);

				const TILE_X_COUNT = 9;
				const TILE_Y_COUNT = 8;
				var width = Math.ceil(img.naturalWidth / TILE_X_COUNT);
				var height = Math.ceil(img.naturalHeight / TILE_Y_COUNT);
				const LAYER_COUNT = (TILE_X_COUNT * TILE_Y_COUNT) - 1;

				item.texWidth = width;
				item.texHeight = height;
				item.texDepth = LAYER_COUNT;

				const TILE_BYTES = width * height * 4;
				const TILE_ROW_BYTES = TILE_X_COUNT * TILE_BYTES;
				const SRC_ROW_BYTES = img.naturalWidth * 4;
				
				var src_pos = 0;
				var dst_pos = 0;

				for (var ty = 0; ty < TILE_Y_COUNT; ty++)
				{
					for (var tx = 0; tx < TILE_X_COUNT; tx++)
					{
						for (var y = 0; y < height; y++)
						{
							src_pos = ty*(TILE_ROW_BYTES) + y*SRC_ROW_BYTES + tx*width*4;
							for (var x = 0; x < width; x++)
							{
								// copy one pixel
								for (var i = 0; i < 4; i++)
									dst_data[dst_pos + i] = src_data[src_pos + i];

								src_pos += 4;
								dst_pos += 4;
							}
						}
					}
				}

				console.log(`...done computing 3d tex`);
				item.data = dst_data;

			};
			img.src = item.url;
		});
	},
	mounted () 
	{
		window.addEventListener('mousemove', (evt)=>
		{
			// console.log('mousemove ', evt);
			this.mouse.x = evt.clientX;
			this.mouse.y = evt.clientY;
		});

		window.addEventListener('resize', (evt)=>
		{
			this.onResize();
		});
	},
	methods: 
	{
		getBgImg(item)
		{
			return `url("${item.url}")`;
		},

		onResize()
		{
			if (this.$refs.viewer)
			{
				for (let v of this.$refs.viewer)
					v.onResize();
			}
		},

		calcQuadrant(x, y)
		{
			var box = this.$refs.mainPanel.$el.getBoundingClientRect();
			var middleX = box.left + (box.width / 2);
			var middleY = box.top + (box.height / 2);

			var diffX = x - middleX;
			var diffY = y - middleY;

			if (diffX >= 0 && diffY <= 0)	return 0;
			if (diffX >= 0 && diffY >= 0)	return 1;
			if (diffX <= 0 && diffY >= 0)	return 2;
			if (diffX <= 0 && diffY <= 0)	return 3;
		},

		calcDropOverlayStyle()
		{
			var box = this.$refs.mainPanel.$el.getBoundingClientRect();
			var middleX = box.left + (box.width / 2);
			var middleY = box.top + (box.height / 2);
			var ret = { display: 'inline-block' };
			var x = Math.abs((this.mouse.x ) - middleX);
			var y = Math.abs((this.mouse.y ) - middleY);
			x /= (box.width / 2);
			y /= (box.height / 2);

			// console.log('dropOverlayStyle ', this.mouse.x, this.mouse.y);
			// console.log('dropOverlayStyle ', x, y);

			this.dropOverlayInfo.overViewer = null;

			if (this.viewers >= 4 || 
				this.mouse.x < box.left ||
				this.mouse.x > box.right ||
				this.mouse.y < box.top ||
				this.mouse.y > box.bottom)
			{
				this.dropOverlayStyle = { display: 'none' };
				this.dropOverlayInfo.overViewer = null;
				this.dropOverlayInfo.quadrants = [];
				return;
			}

			if (this.viewers.length == 0)
			{
				ret.left = 0 + 'px';
				ret.top = 0 + 'px';
				ret.width = '100%';
				ret.height = '100%';
				this.dropOverlayStyle = ret;
				this.dropOverlayInfo.overViewer = null;
				this.dropOverlayInfo.quadrants = [0, 1, 2, 3];
				return;
			}

			const BRD_WIDTH = 12;
			for (let item of this.$refs.viewer)
			{
				var el = item.$el;
				var rect = el.getBoundingClientRect();
				var centerX = rect.left + (rect.width / 2);
				var centerY = rect.top + (rect.height / 2);
				var diffX = Math.abs(this.mouse.x - centerX);
				var diffY = Math.abs(this.mouse.y - centerY);
				if (diffX < rect.width/4 && diffY < rect.height/4)
				{
					// console.log('diff ', diffX, diffY);
					this.dropOverlayInfo.overViewer = item;
					ret.border = BRD_WIDTH + 'px solid rgba(93, 173, 243, 0.45)';
					ret.background = 'none';
					ret.left = (rect.left - box.left ) + 'px';
					ret.top = (rect.top - box.top ) + 'px';
					ret.width = (rect.width - (BRD_WIDTH*2)) + 'px';
					ret.height = (rect.height - (BRD_WIDTH*2)) + 'px';
					this.dropOverlayStyle = ret;

					return;
				}
			}

			this.dropOverlayInfo.overViewer = null;


			const EDGE = 0.8;
			if (this.viewers.length > 1 && (x > EDGE || y > EDGE))
			{
				ret.width = '50%';
				ret.height = '50%';
				if (this.mouse.x <= middleX)
				{
					ret.left = 0;
					if (this.mouse.y <= middleY)
						this.dropOverlayInfo.quadrants = [3];
					else
						this.dropOverlayInfo.quadrants = [2];
				}
				else
				{
					ret.left = box.width / 2;
					if (this.mouse.y <= middleY)
						this.dropOverlayInfo.quadrants = [0];
					else
						this.dropOverlayInfo.quadrants = [1];
				}

				if (this.mouse.y <= middleY)
				{
					ret.top = 0;
				}
				else
				{
					ret.top = box.height / 2;
				}
			}
			else
			{
				if (this.mouse.x <= middleX)
				{
					ret.left = 0;
					ret.width = '50%';
					
					if (x > y)
					{
						ret.width = '50%';
						ret.top = 0;
						ret.height = '100%';
						this.dropOverlayInfo.quadrants = [2, 3];
					}
					else
					{
						ret.width = '100%';
						ret.height = '50%';
						if (this.mouse.y <= middleY)
						{
							ret.top = 0;
							this.dropOverlayInfo.quadrants = [0, 3];
						}
						else
						{
							ret.top = box.height / 2;
							this.dropOverlayInfo.quadrants = [1, 2];
						}
					}
				}
				else
				{
					ret.left = box.width / 2;
					ret.width = '50%';

					if (x < y)
					{
						ret.left = 0;
						ret.width = '100%';
						ret.height = '50%';
						if (this.mouse.y <= middleY)
						{
							ret.top = 0;
							this.dropOverlayInfo.quadrants = [0, 3];
						}
						else
						{
							ret.top = box.height / 2;
							this.dropOverlayInfo.quadrants = [1, 2];
						}
					}
					else
					{
						ret.left = box.width / 2;
						ret.top = 0;
						ret.width = '50%';
						ret.height = '100%';
						this.dropOverlayInfo.quadrants = [0, 1];
					}

					// if (this.mouse.y <= middleY)
					// {
					// 	ret.top = 0;
					// 	// ret.bottom = middleY;
					// 	ret.height = '50%';
					// }
					// else
					// {
					// 	ret.top = box.height / 2;
					// 	// ret.bottom = box.bottom;
					// 	ret.height = '50%';
					// }
				}
			}

			ret.left += 'px';
			// ret.right += 'px';
			ret.top += 'px';
			// ret.bottom += 'px';

			// console.log('dropOverlayStyle ', ret);

			this.dropOverlayStyle = ret;
		},

		onDragOver(item, event)
		{
			this.mouse.x = event.clientX;
			this.mouse.y = event.clientY;

			if (!item.$vnode)
			{
				this.isDragging = true;
				this.calcDropOverlayStyle();
			}
			else
			{
				this.isDragging = false;
			}

			// console.log('onDragOver: ', event);
		},

		onDrop(data)
		{
			console.log('onDrop: ', data);
			this.isDragging = false;
			if (data.$vnode)
			{
				let src = data.layout;
				let q = this.calcQuadrant(this.mouse.x, this.mouse.y);
				let replace = this.viewerQuadrants[q];
				if ( replace == src)
				{
					return;
				}
				let list = this.viewerQuadrants.slice(); // shallow copy
				for (let i = 0; i < list.length; i++)
				{
					if (this.viewerQuadrants[i] == src)
						list[i] = replace;
					if (this.viewerQuadrants[i] == replace)
						list[i] = src;
				}

				this.viewerQuadrants = list;
			}
			else
			{
				if (this.viewers.length==0)
				{
					let viewer = new Viewer( (new Date()).getTime() );
					this.viewers.push( viewer );
					this.viewerQuadrants = [viewer, viewer, viewer, viewer];

					this.$nextTick( ()=>
					{
						this.$refs.viewer[this.viewers.length-1].addLayer(data);
					} )

					return;
				}
				
				if (this.dropOverlayInfo.overViewer)
				{
					this.dropOverlayInfo.overViewer.addLayer(data);
					this.dropOverlayInfo.overViewer = null;
				}
				else
				{
					let viewer = new Viewer( (new Date()).getTime() );
					this.viewers.push( viewer );
					// viewer.style = this.dropOverlayStyle;
					let quadrants = this.viewerQuadrants.slice(); // shallow copy
					for (let q of this.dropOverlayInfo.quadrants)
						quadrants[q] = viewer;
					this.viewerQuadrants = quadrants;

					this.$nextTick( ()=>
					{
						this.$refs.viewer[this.viewers.length-1].addLayer(data);
					} )
				}
			}
		},

		onRemoveViewer(item)
		{
			var idx = this.viewers.indexOf(item.layout);
			if (idx > -1)
				this.viewers.splice(idx, 1);

			for (let i = 0; i < this.viewerQuadrants.length; i++)
			{
				if (this.viewerQuadrants[i] == item.layout)
					this.viewerQuadrants[i] = null;
			}

			if (this.viewers.length > 0)
			{
				if (this.viewers.length > 1)
				{
					for (let i = 0; i < this.viewerQuadrants.length; i++)
					{
						if (!this.viewerQuadrants[i])
						{
							let prev = this.viewerQuadrants[mod(i-1, 4)];
							if (prev)
							{
								if (countInArray(this.viewerQuadrants, prev) < 2)
									this.viewerQuadrants[i] = prev;
								else
									this.viewerQuadrants[i] = this.viewerQuadrants[(i+1) % 4];
							}
							else
							{
								this.viewerQuadrants[i] = this.viewerQuadrants[(i+1) % 4];
							}
						}
					}
				}
				else
				{
					for (let i = 0; i < this.viewerQuadrants.length; i++)
						if (!this.viewerQuadrants[i])
							this.viewerQuadrants[i] = this.viewerQuadrants[mod(i-1, 4)];
				}

				// shallow copy to force the watcher to re-layout remaining viewers
				this.viewerQuadrants = this.viewerQuadrants.slice(); 
			}
		}
	},
}
</script>

<style lang="sass">

html, body
	display: block
	width: 100%
	height: 100%
	padding: 0
	margin: 0

#app 
	display: block

	font-family: 'Avenir', Helvetica, Arial, sans-serif
	-webkit-font-smoothing: antialiased
	-moz-osx-font-smoothing: grayscale
	text-align: center
	color: #2c3e50
	width: 100%
	height: 100%

.fulscreen
	position: fixed
	left: 0
	top: 0
	right: 0
	bottom: 0

.flex
	display: flex
	position: relative
	flex-direction: row

.flex-center
	display: flex
	width: 100%
	height: 100%
	align-items: center
	justify-content: center
	text-align: center

.left-panel
	display: flex
	position: relative
	flex-direction: column
	align-self: start
	width: 100px
	height: 100vh
	// transition: 
	// background: #676767
	// background: black
	background: #2b2b2b

	&.is-closed
		overflow: hidden
		width: 0 !important


.left-panel-toggle-wrapper
	display: inline-block
	position: absolute
	left: 0
	top: 10px
	width: 20px
	height: 20px
	background: #2b2b2b
	cursor: pointer

.toggle-button
	display: block
	margin: 6px
	background: #2b2b2b
	pointer-events: none

.triangle-icon
	width: 0
	height: 0
	border-top: 4px solid transparent
	border-right: 6px solid grey
	border-bottom: 4px solid transparent
	background: #2b2b2b

	&.invert
		transform: rotate(180deg)

.main-panel
	flex: 1 1 auto
	justify-content: center

.drop-overlay
	display: inline-block
	position: absolute
	background: rgba(93, 173, 243, 0.45)
	pointer-events: none


.thumbnail
	display: block
	cursor: grab
	margin: 15px auto

.thumbnail-title
	display: block
	text-align: center
	font-size: 15px
	color: white
	margin-bottom: 10px


@keyframes thumb-loop
	@for $y from 0 through 8
		@for $x from 0 through 9
			@if ($y*9 + $x) < 72
				#{(100% * ( ($y*9 + $x) /71))}
					background-position: #{(100% * $x/8)} #{(100% * $y/7)}

.thumbnail-img
	display: block
	position: relative
	background-repeat: no-repeat
	background-size: (9*100%) (8*100%)
	// background-position: (-4*100%) (-4*100%)
	background-position: #{(100% * 4/8)} #{(100% * 4/7)}
	width: 68px
	height: 90px

	&:hover
		animation: thumb-loop 3s steps(1) infinite alternate
		// background-color: darkblue


	&.is-loading

.lds-ring
	display: inline-block
	position: relative
	width: 32px
	height: 32px
	margin-top: 30px
	div
		box-sizing: border-box
		display: block
		position: absolute
		width: 31px
		height: 31px
		margin: 3px
		border: 3px solid #fff
		border-radius: 50%
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite
		border-color: #fff transparent transparent transparent

		&:nth-child(1)
			animation-delay: -0.45s
		&:nth-child(2)
			animation-delay: -0.3s
		&:nth-child(3)
			animation-delay: -0.15s

@keyframes lds-ring
	0%
		transform: rotate(0deg)

	100%
		transform: rotate(360deg)




</style>
